// extracted by mini-css-extract-plugin
module.exports = {"headlineHover":"WaffleHeadlineStyles_headlineHover__mV4Gg","disabled":"WaffleHeadlineStyles_disabled__3I7Mw"};